import { LoaderService } from 'core/services';
import { DsgDeepTranslationKey } from 'projects/designer/src/app/pipes/translate.pipe';
import { Observable } from 'rxjs';
import { LProcessEntity } from '../../types/l-process.entity';
import { LMethodKey } from '../types/l-method-key';

const applyEntityLoader = (entity: LProcessEntity) => <T extends any>(params: {
    obs: Observable<T>,
    loaderService: LoaderService<DsgDeepTranslationKey>,
    methodKey: LMethodKey,
    subtle?: boolean,
    suffix?: string,
    text?: DsgDeepTranslationKey
}) => {
    const { subtle, loaderService, methodKey, obs, suffix, text } = params;

    const id = loaderService.show({
        key: entity + '.' + methodKey + (suffix ? '.' + suffix : ''),
        text: text || 'ss-entities.' + entity + '.remote-actions.' + methodKey as DsgDeepTranslationKey,
        subtle
    });

    return obs.pipe(loaderService.disposeLoader(id))
}

export default applyEntityLoader;